import { FORM_VALIDATION_MSG } from '../constants';
const getDefaultNoFreightInfo = () => {
  return {
    contactName: '',
    callTime: '',
    comments: '',
    errorInfo: {
      contactName: '',
      callTime: '',
      comments: ''
    }
  };
};

const getFieldError = (field, value) => {
  switch (field) {
    case 'contactName':
    case 'callTime':
    case 'comments':
      return value?.trim() ? null : FORM_VALIDATION_MSG.REQUIRED;
    default:
      return null;
  }
};

const getNoFreightErrorInfo = (errorInfo, noFreightPickupData) => {
  const newErrorInfo = {};
  Object.keys(errorInfo).forEach((fieldName) => {
    newErrorInfo[fieldName] = getFieldError(fieldName, noFreightPickupData[fieldName]);
  });
  return newErrorInfo;
};

export { getDefaultNoFreightInfo, getFieldError, getNoFreightErrorInfo };
